import React, { useEffect, useState } from 'react';
import axios from 'axios';

const LocationServiceChecker = () => {
  const [location, setLocation] = useState(null);
  const [error, setError] = useState(null);
  const OPENCAGE_API_KEY = process.env.REACT_APP_OPENCAGE_API_KEY;

  useEffect(() => {
    const fetchLocation = async () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const { latitude, longitude } = position.coords;
            try {
              const response = await axios.get(
                `https://api.opencagedata.com/geocode/v1/json?q=${latitude}+${longitude}&key=${OPENCAGE_API_KEY}&language=th`
              );
              const address = response.data.results[0]?.formatted || "ไม่พบที่อยู่";
              setLocation(address);
            } catch (err) {
              setError('เกิดข้อผิดพลาดในการดึงข้อมูลที่อยู่');
            }
          },
          () => setError('ไม่ได้รับอนุญาตให้เข้าถึงตำแหน่ง'),
        );
      } else {
        setError('เบราว์เซอร์นี้ไม่รองรับการระบุตำแหน่ง');
      }
    };

    fetchLocation();
  }, [OPENCAGE_API_KEY]);

  return (
    <div
      className="location-service-checker mt-0 mb-4"
      style={{
        background: 'linear-gradient(90deg, #e0ffe6 0%, #f0f9ff 100%)',
        borderRadius: '16px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
        padding: '14px 14px',
        maxWidth: 350, // ขยายให้เหมาะกับข้อความภาษาไทย
        marginLeft: 0, // ชิดซ้าย
        marginRight: 0,
        textAlign: 'center', // ชิดซ้าย
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 }}>
        <span style={{ fontSize: 18, marginRight: 10, color: '#4CAF50' }}>
          <i className="fas fa-map-marker-alt"></i>
        </span>
        <h2 style={{ margin: 0, fontWeight: 700, color: '#2d3a4b', fontSize: 16 }}>
          ที่อยู่ปัจจุบันของคุณ
        </h2>
      </div>
      {error && <p style={{ color: '#e12121', fontWeight: 600 }}>{error}</p>}
      {location && (
        <p style={{ fontSize: 12, color: '#333', margin: 0 }}>
          <i className="fas fa-location-arrow" style={{ color: '#2196f3', marginRight: 8 }}></i>
          {location}
        </p>
      )}
      {!location && !error && (
        <p style={{ color: '#888', fontSize: 16 }}>กำลังค้นหาตำแหน่งของคุณ...</p>
      )}
    </div>
  );
};

export default LocationServiceChecker;